import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackGAPageView } from '../utils/googleAnalytics';

/** Fire GA4 page_view on SPA route changes (initial load handled in index.html). */
export default function useGoogleAnalytics() {
  const { pathname, search } = useLocation();
  const skipInitial = useRef(true);

  useEffect(() => {
    if (skipInitial.current) {
      skipInitial.current = false;
      return;
    }
    trackGAPageView(`${pathname}${search || ''}`);
  }, [pathname, search]);
}
